'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled img
 * @private
 * @type {StyledComponent}
 * @param {Object} props
 *   The properties
 * @param {Function} props.innerRef
 * @param {String} props.alt
 * @param {String} props.src
 * @param {?String} [props.title]
 */
var Img = _styledComponents2.default.img.withConfig({
  displayName: 'img__Img'
})(['display:none;']);

/**
 * @private
 * @return {{onLoad: Function, innerRef: Function, src: String, alt: String, title ?String)}}
 *   Allowed propTypes for `<Img/>`
 */
Img.propTypes = {
  onLoad: _propTypes2.default.func,
  innerRef: _propTypes2.default.func,
  src: _propTypes2.default.string.isRequired,
  alt: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string
};

exports.default = Img;